var baseURL = '';
export const environment = {
  production: false,
  name: 'development',
  appConfig: {
    apisBaseUrl: "https://gateway.miyarcapital.dev",
    notificationServiceBaseUrl: "https://notification.miyarcapital.dev",
    awsUrl: "https://mr-oss-dev-01.oss-me-central-1.aliyuncs.com/",
    moyassarPublishableKey: "pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi"
  },
  mapKey: "AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g",
};
